<template>
  <div class="table-section">
    <div class="table-scroll-area">
      <table class="users-table">
        <thead>
          <tr>
            <th class="name-column">Name</th>
            <th class="email-column">Email</th>
            <th class="created-column">Created</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(user, index) in paginatedUsers" :key="user.id" :class="{ 'stripe-row': index % 2 === 1 }">
            <td class="name-cell">
              <strong>{{ getUserFullName(user) }}</strong>
            </td>
            <td class="email-cell">
              {{ user.email }}
            </td>
            <td class="created-cell">
              {{ user.created_at | fixDateTime }}
            </td>
          </tr>
          <tr v-if="paginatedUsers.length === 0" class="empty-row">
            <td colspan="3" class="empty-cell">
              {{ searchQuery ? 'No users found' : 'No users without inbox access' }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="pagination-section">
      <el-pagination
        :current-page="internalCurrentPage"
        :page-size="internalPageSize"
        :page-sizes="[10, 20, 50]"
        :total="users.length"
        layout="sizes, prev, pager, next"
        background
        @current-change="handlePageChange"
        @size-change="handleSizeChange"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'TeamInboxAlertTable',
  
  props: {
    users: {
      type: Array,
      required: true
    },
    searchQuery: {
      type: String,
      default: ''
    },
    currentPage: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 10
    }
  },
  
  data() {
    return {
      internalCurrentPage: this.currentPage,
      internalPageSize: this.pageSize
    }
  },
  
  computed: {
    paginatedUsers() {
      const start = (this.internalCurrentPage - 1) * this.internalPageSize
      const end = start + this.internalPageSize
      return this.users.slice(start, end)
    }
  },
  
  watch: {
    currentPage(newVal) {
      this.internalCurrentPage = newVal
    },
    
    pageSize(newVal) {
      this.internalPageSize = newVal
    },
    
    users() {
      // Reset to first page when users change (e.g., search)
      this.internalCurrentPage = 1
      this.$emit('update:currentPage', 1)
    }
  },
  
  methods: {
    getUserFullName(user) {
      return `${user.first_name} ${user.last_name}`.trim()
    },
    
    handlePageChange(page) {
      this.$emit('update:currentPage', page)
    },
    
    handleSizeChange(size) {
      this.$emit('update:pageSize', size)
    }
  }
}
</script>

<style lang="scss" scoped>
.table-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;

  .table-scroll-area {
    flex: 1;
    overflow-y: auto;
    padding: 0 20px;

    .users-table {
      width: 100%;
      border-collapse: collapse;
      font-size: 14px;
      
      thead {
        th {
          position: sticky;
          top: 0;
          background-color: #f5f7fa;
          color: #303133;
          font-weight: 700;
          text-align: left;
          padding: 12px 16px;
          border-bottom: 1px solid #e4e7ed;
          z-index: 100;
          
          &.name-column {
            width: 40%;
          }
          
          &.email-column {
            width: 40%;
          }
          
          &.created-column {
            width: 20%;
          }
        }
      }
      
      tbody {
        tr {
          border-bottom: 1px solid #ebeef5;
          
          &.stripe-row {
            background-color: #fafafa;
          }
          
          td {
            padding: 12px 16px;
            color: #606266;
            
            &.name-cell {
              width: 40%;
              
              strong {
                color: #303133;
              }
            }
            
            &.email-cell {
              width: 40%;
              color: #303133;
            }
            
            &.created-cell {
              width: 20%;
              color: #303133;
            }
          }
        }
        
        .empty-row {
          td.empty-cell {
            text-align: center;
            color: #909399;
            padding: 40px 0;
            font-size: 14px;
          }
        }
      }
    }

    @media (max-width: 768px) {
      padding: 0 15px;
    }
  }

  .pagination-section {
    flex-shrink: 0;
    background: white;
    border-top: 1px solid #e4e7ed;
    padding: 12px 20px;
    display: flex;
    justify-content: flex-end;

    @media (max-width: 768px) {
      padding: 10px 15px;

      ::v-deep .el-pagination {
        .el-pagination__sizes {
          display: none;
        }
      }
    }
  }
}
</style>